export function resizeIframeHeight(iframeId, height, unit) {
    const iframeEl = document.querySelector(`#${iframeId}`);
    // @ts-ignore: Comprends pas pourquoi cette erreur
    if (iframeEl)
        iframeEl.style.height = unit === '%' ? `${height}%` : `${height}px`;
}
export function setIframeMinHeight(iframeId, minHeightCalc) {
    const iframeEl = document.querySelector(`#${iframeId}`);
    // @ts-ignore: Comprends pas pourquoi cette erreur
    if (iframeEl)
        iframeEl.style.minHeight = minHeightCalc;
}
//# sourceMappingURL=app.js.map